import React from 'react'
import { setCookie, getCookie } from './cookie'
import {ASSEMBLE_SERVICE} from "../utils/serviceItem";

export const arrayShuffle = function(o) {
    for (var j, x, i = o.length; i; j = parseInt(Math.random() * i, 10), x = o[--i], o[i] = o[j], o[j] = x);
    return o
}

export const numberFormat = function(num, m) {
    if (num === undefined || num === '' || num === null) return num
    let numStr = num.toLocaleString()
    if (m) {
        numStr = num.replace(/([^\d]*)/gi, '')
        numStr = parseInt(num.replace(/(,*)/gi, ''), 10)
        if (isNaN(numStr)) numStr = 0
    }
    return numStr
}

export const Offset = function(selector) {
    let dqs = document.querySelector(selector)
    try {
        let rect = dqs.getBoundingClientRect()
        // console.log('logg rect',rect)
        let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop
        let offset = {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            width: rect.width,
            height: rect.height,
        }
        return offset
    } catch (e) {
        return 0
    }
}

export const scrollTo = function(selector, top, behavior = 'smooth') {

    // console.log('selector',selector)
    // console.log('top',top)
    // console.log('behavior',behavior)

    let select = Offset(selector)
    let isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style


    let selectTop = top ? top : 0

    selectTop += select.top

    let options = {
        behavior,
        top: selectTop,
        left: 0,
    }

    if (isSmoothScrollSupported) {
        window.scrollTo(options)
    } else {
        window.scrollTo(options.left, options.top)
    }
}

export const estimate = {
    addEstimateItem(itemId, items, count) {
        if (!items) items = getCookie('item_est')
        count = count || 1
        let estimateItems = items ? items.split(',') : []
        let deleteIdx = estimateItems.indexOf(itemId.toString())
        if (deleteIdx !== -1) {
            if (count === 1) {
                count = getCookie('cnt_' + itemId.toString())
                count = parseInt(count, 10) + 1
            }
            setCookie('cnt_' + itemId.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        } else {
            estimateItems.push(itemId)
            setCookie('item_est', estimateItems.toString(), 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
            setCookie('cnt_' + itemId.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
        return estimateItems.toString()
    },

    addEstimateItems(itemId) {
        let estimates = getCookie('item_est')

        if (typeof itemId === 'object') {
            itemId.map(v => {
                estimates = this.addEstimateItem(v, estimates)
                return estimates
            })
            return estimates
        } else {
            return this.addEstimateItem(itemId, estimates)
        }
    },

    reEstimateItem(itemId, count) {
        if (typeof itemId === 'object') {
            itemId.map(v => {
                setCookie('cnt_' + v.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
                return true
            })
        } else {
            setCookie('cnt_' + itemId.toString(), count, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
    },

    delEstimateItems(itemId, estimates) {
        if (estimates === undefined) {
            estimates = getCookie('item_est')
        }

        if (typeof itemId === 'object') {
            itemId.map(v => {
                estimates = this.delEsitmateItem(estimates, v)
                return true
            })
            return estimates
        } else {
            return this.delEsitmateItem(estimates, itemId)
        }
    },

    delEstimateService(deleteTargetItemId, windowsItemList) {
        deleteTargetItemId = typeof deleteTargetItemId==='number'?deleteTargetItemId.toString():deleteTargetItemId
        let estimates = getCookie('item_est')
        const estimateArr = estimates.split(',')

        /**
         * 조립서비스 삭제 시
         * - 조립서비스, 동봉서비스, 운영체제 설치 서비스, 출장 설치 서비스 삭제
         *
         * 윈도우 삭제 시
         * - 윈도우, 운영체제 설치 서비스
         *
         * 동봉서비스 삭제 시
         * - 동봉서비스만 삭제
         *
         * 운영체제 설치 서비스 삭제 시
         * - 운영체제 설치 서비스만 삭제
         *
         * 출장 설치 서비스 삭제 시
         * - 출장 설치 서비스만 삭제
         *
         */


        if(ASSEMBLE_SERVICE.includes(deleteTargetItemId)){
            estimates = this.delEstimateItems([deleteTargetItemId,'1099785', '1099814','11653042'])
        } else if(windowsItemList.includes(deleteTargetItemId)){
            /**
             * 운영체제 설치 서비스 구매 조건의 윈도우를 삭제 시
             * 마지막 윈도우가 삭제 될때 운영체제 설치 서비스를 삭제 하는 로직
             */
            if(estimateArr.filter((item) => windowsItemList.includes(item)).length === 1){
                estimates = this.delEstimateItems([deleteTargetItemId, '1099814'])
            } else {
                estimates = this.delEstimateItems([deleteTargetItemId])
            }
        } else{
            estimates = this.delEstimateItems([deleteTargetItemId])
        }
        return estimates
    },

    delEsitmateItem(estimateItems, itemId) {
        let estimates = estimateItems ? estimateItems.split(',') : []

        let deleteIdx = estimates.indexOf(itemId.toString())
        if (deleteIdx !== -1) {
            estimates.splice(deleteIdx, 1)
            setCookie('item_est', estimates.toString(), 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
            setCookie('cnt_' + itemId.toString(), null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
        return estimates.toString()
    },

    delEstimateAllItems() {
        const items = getCookie('item_est')

        let estimateItems = items ? items.split(',') : []

        setCookie('item_est', null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        estimateItems.map(v => {
            setCookie('cnt_' + v.toString(), null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
            return true
        })
        return true
    },

    listCompareItems(items) {
        if (!items) {
            items = getCookie('item_compare')
        }

        let compareItems = this.dataToArray(items, '||')

        let compareDatas = compareItems.map((v, _i) => {
            return this.dataToArray(v, '^')
        })
        return compareDatas
    },

    addCompareItems(itemId, compareData) {
        const items = getCookie('item_compare')

        let compareItems = this.dataToArray(items, '||')

        let checkIdx = -1
        compareItems.map((v, i) => {
            const compareData = this.dataToArray(v, '^')
            if (compareData[0] === itemId.toString()) {
                checkIdx = i
            }
            return compareData
        })

        if (checkIdx !== -1) {
            compareItems = this.delCompareItems(itemId)
            return compareItems
        } else {
            compareItems.push(compareData.toString())
            setCookie('item_compare', compareItems.join('||'), 0, '/', `.pping.${process.env.REACT_APP_TLD}`)
            return this.listCompareItems(compareItems.join('||'))
        }
    },

    delCompareItems(itemId) {
        const items = getCookie('item_compare')

        let compareItems = this.dataToArray(items, '||')
        let deleteIdx = -1
        compareItems.map((v, i) => {
            const compareData = this.dataToArray(v, '^')
            if (compareData[0] === itemId.toString()) deleteIdx = i
            return compareData
        })

        if (deleteIdx !== -1) {
            compareItems.splice(deleteIdx, 1)
            setCookie('item_compare', compareItems.join('||'), 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        }
        return this.listCompareItems(compareItems.join('||'))
    },

    delCompareAllItems() {
        setCookie('item_compare', null, 9 * 24 * 60 * 60, '/', `.pping.${process.env.REACT_APP_TLD}`)
        return {}
    },

    dataToArray(d, prefix) {
        if (d) {
            if (prefix) {
                return d.split(prefix)
            }
            return d.split(',')
        }
        return []
    },
}

export const itemImageError = function(e, err) {
    if (e.target.src.indexOf(err) === -1) {
        // e.target.src = err
        e.target.src = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`
    }
}

export const itemImage = function(thumbnail, alt, size, seq, cls) {
    alt = alt ? alt : ''
    let src = thumbnail.imgUrl
    let err = thumbnail.noImgUrl

    if (src === undefined) src = thumbnail.imgPath
    if (err === undefined) err = thumbnail.errorPath

    let getSeq = seq && seq !== '0' && seq !== 0 ? '.' + seq : ''

    if (size === undefined || size === '') {
        src = src + '/200' + getSeq + '.jpg'
        err = err + '_500.png'
    } else {
        src = src + '/' + size + getSeq + '.jpg'
        err = err + '_500.png'
    }
    // console.log(src);
    // console.log(err);
    return <img src={src} onError={e => itemImageError(e, err)} alt={alt} className={cls} />
}

export const itemThumbUrl = (itemId, size = 300) => {
    if (!itemId) {
        console.error('item id error')
    }
    const trans = Math.ceil(parseInt(itemId, 10) / 1000) * 1000
    const imgSrc = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_${trans}/img_${itemId}/${size}.jpg`
    return imgSrc
}

export const filterTheorem = (selectedFilters, data) => {
    if (data.kind === 'spec') {
        let spec = {}
        const selectIndex = selectedFilters.spec?.[data.value.specNameKey]?.findIndex(v => v.specValueKey === data.value.specValueKey)
        if (selectIndex > -1) {
            spec = {
                ...selectedFilters.spec,
                [data.value.specNameKey]: selectedFilters.spec[data.value.specNameKey].filter(v => v.specValueKey !== data.value.specValueKey)
            }
        } else {
            spec = {
                ...selectedFilters.spec,
                [data.value.specNameKey]: [...selectedFilters.spec[data.value.specNameKey] || [], data.value]
            }
        }
        return { spec }
    } else if (data.kind === 'brand') {
        let brand = []
        const selectIndex = selectedFilters?.maker?.findIndex(v => v.maker_id === data.value.maker_id)
        if (selectIndex > -1) {
            brand = selectedFilters.maker.filter(v => v.maker_id !== data.value.maker_id)
        } else {
            brand = [
                ...selectedFilters.maker,
                data.value
            ]
        }
        return { maker: brand }
    } else if (data.kind === 'kwd') {
        return { kwd: data.value }
    } else if (data.kind === 'price') {
        return {
            min: data.value[0],
            max: data.value[1]
        }
    }
}



// WEBPACK FOOTER //
// ./src/estimate_list/libs/util.js